<div class="container">
    <div class="header">
        <div class="top-heading">
            <div class="logo text-align-center"></div>
            <br />
            <h1 class="side-title" id="brand-heading">
                Merlin.net&trade; Patient Care Network
            </h1>
        </div>
        <hr class="divider" />
    </div>
    <div id="wrapper">
        <div class="content-wrapper">
            <div
                class="error pageLevel"
                aria-hidden="false"
                role="alert"
                tabindex="-1"
            >
                <p tabindex="-1" [innerHTML]="message"></p>
            </div>
            <div class="button">
                <button
                    id="continue"
                    type="submit"
                    aria-disabled="false"
                    aria-label="Continue"
                    (click)="clickToSignIn()"
                >
                    {{ btnLabel }}
                </button>
            </div>
        </div>
    </div>
    <footer id="brand-footer">
        <ul>
            <li class="list-item" style="cursor: pointer">
                <span
                    class="item-value"
                    data-translate="label.gb.terms_cond"
                    onclick="websiteTermsClick()"
                >
                    Terms of use</span
                >
                <span class="line-gap">|</span>
            </li>
            <li class="list-item" style="cursor: pointer">
                <span class="item-value" onclick="privacyPolicyClick()"
                    >Privacy policy</span
                >
                <span class="line-gap">|</span>
            </li>
            <li class="list-item" style="cursor: pointer">
                <span class="item-value" onclick="contactUsClick()"
                    >Contact Us</span
                ><span class="line-gap">|</span>
            </li>
            <li class="list-item" style="cursor: pointer">
                <span class="item-value" onclick="cardiWebsite()"
                    >www.cardiovascular.abbott</span
                ><span class="line-gap">|</span>
            </li>
            <!-- <li class="list-item" style="cursor: pointer">
                            <span
                                id ="teconsent"
                            ></span
                            >
                        </li> -->
        </ul>
        <span id="brand-copyright" style="cursor: default"
            >Merlin.net™ © <span>{{currentYear}}</span> Abbott</span
        >
    </footer>
</div>
